const redirectToHappinessSurvey = (happinessSurveyPath, { returnTo } = {}) => {
  const returnToQuery = returnTo ? `?returnTo=${returnTo}` : ""

  window.location.href = `${happinessSurveyPath}${returnToQuery}`
}

export default redirectToHappinessSurvey
